module.exports = __webpack_public_path__ + "static/4671555_orig-0c9142cece711a30002e4a256cfce29e.jpg";